import React from 'react';
import blank_img2 from '../../images/blank_img2.png'
const PolicySection = (props) => {

    return (
        <section className="section_space policy_section">
            <div className="container">
                <div className="row">
                       <div className='col-md-12 text-center'>
                        <h2>Less ‘just a second’.</h2>
                       </div>
                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={blank_img2} />
                                <h4>Return on Investment</h4>
                                <br/>
                                <h4>More Bookings</h4>
                                <p className='desp_div'>Attract more reservations using our direct booking engine and watch your revenue soar.</p>
                           </div>
                        </div>

                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={blank_img2} />
                                <h4>Saved per booking</h4>
                                <br/>
                                <h4>More Control</h4>
                                <p className='desp_div'>Save time using our centralised guest and property management features. We have the tools you need.</p>
                           </div>
                        </div>

                        <div className="col-lg-4">
                            <div className='text-center policy_section_item'>
                                <img src={blank_img2} />
                                <h4>Return on Investment</h4>
                                <br/>
                                <h4>More Bookings</h4>
                                <p className='desp_div'>“Little Hotelier’s mobile app makes coordination of rooms & rates across providers simple and straightforward.” </p>
                           </div>
                        </div>
                </div>
            </div>
        </section>
    );
}

export default PolicySection;